import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { fontWeights } from "et3-ui-library";
import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";

const KhattabatUserLinks = withLiteObserverAndTheme(() => {
  const {
    currentUserIsUnderCsrInvestigation,
    goToUserMessagesPage,
    goToUserPaymentsPage,
    goToUserEventsPage
  } = getUserAdvancedStore();
  const { userIsUnderCsrInvestigation } =
    currentUserIsUnderCsrInvestigation.get();

  return (
    <Stack spacing={1}>
      <Typography fontWeight={fontWeights.semibold}>
        {i18n.get("USER_ACTION_BUTTONS")}
      </Typography>
      <Paper
        variant="outlined"
        sx={{
          p: 2,
          borderWidth: 2,
          borderColor: userIsUnderCsrInvestigation ? "error.main" : "divider"
        }}
      >
        <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
          <Button variant="outlined" onClick={goToUserMessagesPage}>
            {i18n.get("USER_MESSAGES")}
          </Button>
          <Button variant="outlined" onClick={goToUserPaymentsPage}>
            {i18n.get("USER_PAYMENTS")}
          </Button>
          <Button variant="outlined" onClick={goToUserEventsPage}>
            {i18n.get("USER_EVENTS")}
          </Button>
        </Stack>
      </Paper>
    </Stack>
  );
});

export default KhattabatUserLinks;
